import { compareLicensePlates } from 'noddi-util';
import { useBookingCars, useBookingSelectedSalesItemsCars } from './bookingStore';

export const useIsAddonsAvailable = () => {
  const selectionResultsCars = useBookingSelectedSalesItemsCars();
  return selectionResultsCars.map((car) => car.isAddonsAvailable).includes(true);
};

export const useIsTireHotelPickupRequired = () => {
  const selectionResultsCars = useBookingSelectedSalesItemsCars();
  return selectionResultsCars.map((car) => car.isWheelPickupRequired).includes(true);
};

export const useIsMultipleCarsBooking = () => {
  const selectedCars = useBookingCars();
  return selectedCars.length > 1;
};

/** Rows whose item asks which wheel set goes into storage, one per car. */
export const useIncomingTireSeasonItems = () => {
  const selectedSalesItemsCars = useBookingSelectedSalesItemsCars();
  return selectedSalesItemsCars.filter(
    (item, index, items) =>
      item.isIncomingTireSeasonRequired &&
      items.findIndex(
        (other) => other.isIncomingTireSeasonRequired && compareLicensePlates(other.licensePlate, item.licensePlate)
      ) === index
  );
};

export const useIsIncomingTireSeasonStepValid = () => {
  const selectedSalesItemsCars = useBookingSelectedSalesItemsCars();
  return selectedSalesItemsCars.every(
    (item) => !item.isIncomingTireSeasonRequired || item.metaData?.incomingTireSeason
  );
};
